import { Injectable, inject } from '@angular/core';
import type {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { HttpContextToken } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../core/services/loader.service';

// Context token to skip loader for specific requests
export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private loaderService = inject(LoaderService);
  private activeRequests = 0;

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Check if request should show loader using context
    const shouldShowLoader = !req.context.get(SKIP_LOADER);

    if (shouldShowLoader) {
      // Increment active requests counter
      this.activeRequests++;

      // Show loader only on first request
      if (this.activeRequests === 1) {
        this.loaderService.show('Loading...');
      }
    }

    return next.handle(req).pipe(
      finalize(() => {
        if (shouldShowLoader) {
          // Decrement active requests counter
          this.activeRequests--;

          // Hide loader only when all requests are complete
          if (this.activeRequests === 0) {
            this.loaderService.hide();
          }
        }
      })
    );
  }
}
